const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export default TOGGLE_SIDEBAR;
